import React, { Component } from "react";
import Table from "../../components/Table/UserTable.jsx";
import {getResponds} from '../../services/GameServices';
class ViewResponse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            responses:[]
        };
    }
    componentDidMount(){
        //call api 
        //set state of responses
        getResponds().then((response) => {
            if (response.data.err) {
              console.log("err in response")
              console.log(response.data.err);
            } 
            else {
                
              let rd= response.data;
              console.log('response is cool ',rd);
              console.log("State obj",rd.responses);
              this.setState({responses:rd.responses});
            }
          })
          .catch((err) => {
            console.log("Catch an eror in geting responses",err)
          });
    }
    render() {
        return (

            <div style={{padding:10}}>
                <h1> Table of responses</h1>
                <Table
                objecttype="responses"
                answers={this.state.responses}
                attributes={["Winter", "Spring", "Summer","Late Summer","Autumn","Winter Imbalance", "Spring Imbalance", "Summer Imbalance","Late Imbalance","Autumn Imbalance"]}
              />
            </div>

        );
    }

}
export default ViewResponse;


// WEBPACK FOOTER //
// ./src/views/Quiz/ViewResponse.jsx